import React from 'react';
import { Layout } from './TeaserElement.styles';
import { useVideoConfig } from '../../config/VideoAppContext';
import { AspectPlaceholder } from '../Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaElementPlaceholder = () => {
  const {
    usePreview
  } = useVideoConfig();
  return /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsx(AspectPlaceholder, {
      aspectRatio: 16 / 9,
      isPreview: usePreview
    })
  });
};